
export default function numberColumnFormatter(value, options = { digits: 1 }, percentToDecimal=false) {
  if (value === null || value === undefined){
    return '-';
  }

  let number = Number(value);

  if (isNaN(number)) {
    return '-';
  }

  if(percentToDecimal) return `${number/100}`

  if (options.digits === 0) {
    return `${Math.trunc(number)}`;
  }
  else {
    let digits = options.digits;
    const value = number.toFixed(10).toString();
    return `${value.slice(0,value.length-(10-digits))}`;
  }
}
